<template>
  <autocomplete
    :label="label || $t('shifts')"
    v-model="model"
    :items="shifts"
    :hide-details="hideDetails"
    :multiple="multiple"
    :style="{ width }"
    :color="color"
    :item-text="itemText"
    :item-value="itemValue"
    :return-object="returnObject"
    :disabled="disabled"
  ></autocomplete>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  name: "ShiftPicker",
  mixins: [hasModel],
  props: {
    shifts: {
      type: Array,
      required: false,
      default: () => [1, 2, 3, 4],
    },
    returnObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
    itemText: {
      type: String,
      required: false,
      default: "name",
    },
    itemValue: {
      type: String,
      required: false,
      default: "id",
    },
    width: {
      type: String,
      required: false,
      default: "150px",
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: true,
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>
